<template>
    <div>
        <van-row class="text-center">
            <van-col v-for="(item,index) in materialImgs" :key="index" span="8" class="p-b-10">
            <van-image @click="handleImgStations(item)" lazy-load width="100" height="70" fit="cover" :src="item.fileKey+'?x-oss-process=image/resize,h_70'" />
            <p>{{item.brandName.substr(0,6)}}</p>
            </van-col>
        </van-row>
    </div>
</template>

<script>
import { Col, Row, Image as VanImage, ImagePreview, Icon } from 'vant'
import { getMaterialBasicInfoPage } from '@/api/msp'
// import { ParseDate } from '@/utils/dataformat'

export default {
  props: {
    pageNumber: Number,
    query: Object,
    imgs: Array
  },
  components: {
    [Col.name]: Col,
    [Row.name]: Row,
    [VanImage.name]: VanImage,
    [Icon.name]: Icon

  },
  data () {
    return ({
      materialImgs: [],
      materialQuery: {
        assetId: 0,
        pageSize: 6,
        pageNumber: 1,
        orderType: 1,
        produceType: 1,
        startDateStr: '2020-01-01',
        // endDatStr: ParseDate(new Date()),
        endDatStr: '2020-10-01'
      }
    })
  },
  mounted () {
    this.materialQuery.assetId = this.query.assetId
    if (this.pageNumber === 1) {
      this.materialImgs = this.imgs
    } else {
      this.materialQuery.pageNumber = this.pageNumber
    }
    this.loadLineMspImage()
  },
  methods: {
    loadLineMspImage () {
      if (this.materialImgs.length > 0) { return }

      getMaterialBasicInfoPage(this.materialQuery).then(res => {
        this.materialImgs = res.list
      })
    },
    handleImgPreview (index) {
      ImagePreview({
        images: this.materialImgs.map(x => x.fileKey),
        startPosition: index,
        closeable: true
      })
    },
    handleImgStations (param) {
      this.$emit('on-demand-stations', param)
    }
  }
}
</script>
